module.exports = __webpack_public_path__ + "media/fonts/Oricons-64963156e6e0add1097c8edb448ff71a.eot";